module.exports = __webpack_public_path__ + "static/media/福利笔记@2x.6bd29922.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/福利笔记@2x.png
// module id = 1582
// module chunks = 0